import useBackendClient from "@/client";
import { Reward } from "@/modules/Rewards/types";

export const getRewards = async (appId: string, versionId: string) => {
  const { client } = useBackendClient();
  try {
    const response = await client.get<Reward[]>(`/app/${appId}/version/${versionId}/rewards`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch rewards. Error:", error);
    throw error;
  }
};
